const NotificationMenuIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path
        d="M17.436 6C18.817 6 19.936 7.119 19.936 8.5C19.936 9.881 18.817 11 17.436 11C16.055 11 14.936 9.881 14.936 8.5C14.936 7.119 16.056 6 17.436 6"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.736 6.67623C14.958 6.04823 13.982 5.65723 12.905 5.65723H12.907H11.094C8.592 5.65723 6.563 7.68523 6.563 10.1882V10.1882V12.9852C6.563 13.5152 6.352 14.0242 5.977 14.3992L5.336 15.0402C4.961 15.4152 4.75 15.9242 4.75 16.4542V16.4542C4.75 17.4982 5.596 18.3442 6.64 18.3442H17.361C18.405 18.3442 19.251 17.4982 19.251 16.4542V16.4542C19.251 15.9242 19.04 15.4152 18.665 15.0402L18.024 14.3992C17.649 14.0242 17.438 13.5152 17.438 12.9852V10.9992"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.70801 18.3438V18.7088C9.70801 19.9738 10.734 20.9998 12 20.9998V20.9998C13.266 20.9998 14.292 19.9738 14.292 18.7078V18.3428"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.833 5.751V4.833C13.833 3.821 13.013 3 12 3V3C10.987 3 10.167 3.821 10.167 4.833V5.751"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default NotificationMenuIcon;
